import { KybDocument, OnboardingCompanyProfile } from '__generated__/GQL';
import isEi from 'features/Onboarding/common/isEi';

import getCompanyPapersDocumentType from './getCompanyPapersDocumentType';

/**
 * Returns the KYB document we require for a company's proof of registration, if there is one.
 */
const getCompanyPapersDocument = <
  TKybDocument extends Pick<KybDocument, 'type'>,
>({
  companyProfile,
  kybDocuments,
}: {
  companyProfile: Pick<OnboardingCompanyProfile, 'legalForm'>;
  kybDocuments: TKybDocument[];
}) => {
  const documentType = getCompanyPapersDocumentType({
    isEi: isEi(companyProfile.legalForm),
  });

  return kybDocuments.find(({ type }) => type === documentType);
};

export default getCompanyPapersDocument;
